import axios from "axios";

const inFlight = new Map();
export const receiptPrintKey = (doctype, name) => `cayenne.kiosk.printed.${doctype}.${name}`;

export const receiptRetryUsed = (doctype, name) => Boolean(localStorage.getItem(`${receiptPrintKey(doctype, name)}.retry`));

export function printKioskReceipt({ doctype, name, reprint = false }) {
    const key = receiptPrintKey(doctype, name);
    if (inFlight.has(key)) return inFlight.get(key);
    if (reprint) {
        if (receiptRetryUsed(doctype, name)) return Promise.reject(new Error("Receipt retry limit reached"));
        // Consume the one retry before downloading, including failed retries.
        localStorage.setItem(`${key}.retry`, "used");
    } else {
        if (localStorage.getItem(key)) return Promise.resolve();
        if (localStorage.getItem(`${key}.attempted`)) return Promise.reject(new Error("Receipt requires an explicit retry"));
    }
    localStorage.setItem(`${key}.attempted`, "yes");
    const operation = (async () => {
        const response = await axios.post("method/restaurant_management.kiosk_printing.receipt", { doctype, name }, { responseType: "blob" });
        if (!response.data || response.data.type?.split(";")[0] !== "application/pdf") {
            throw new Error("Receipt PDF is unavailable");
        }
        const url = URL.createObjectURL(response.data);
        const frame = document.createElement("iframe");
        frame.title = "Kiosk receipt";
        frame.setAttribute("aria-hidden", "true");
        frame.style.cssText = "position:fixed;left:-10000px;width:1px;height:1px;border:0;";
        const cleanup = () => { frame.remove(); URL.revokeObjectURL(url); };
        try {
            await new Promise((resolve, reject) => {
                const timer = setTimeout(() => reject(new Error("Receipt loading timed out")), 30000);
                frame.onerror = () => { clearTimeout(timer); reject(new Error("Receipt loading failed")); };
                frame.onload = () => {
                    frame.onload = null;
                    clearTimeout(timer);
                    try {
                        // Silent printing is supplied by the kiosk's Chrome launch configuration.
                        frame.contentWindow.print();
                        // Records a browser print request, not proof of physical paper output.
                        localStorage.setItem(key, "requested");
                        resolve();
                    } catch (error) { reject(error); }
                };
                frame.src = url;
                document.body.appendChild(frame);
            });
            // Keep the PDF alive while Chrome spools it; releasing immediately can cancel printing.
            setTimeout(cleanup, 60000);
        } catch (error) {
            cleanup();
            throw error;
        }
    })();
    inFlight.set(key, operation);
    operation.finally(() => inFlight.delete(key)).catch(() => {});
    return operation;
}
